import { Component, OnInit } from "@angular/core";
import { NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { GlobalVariables } from "../../../models/cameralla-global.model";
import { CamerallaUser } from "../../../models/cameralla-user.model";
import { PermissionAdminService } from "../../../services/guard-services/permission-admin.service";
import { HeaderComponent } from "../header/header.component";

@Component({
  selector: "app-main-navigation",
  templateUrl: "./navigation.component.html",
})
export class NavigationComponent extends HeaderComponent implements OnInit {
  public site = environment["site"];
  public headerLink = environment["header_footer_link"];
  public menus = [];
  public user: CamerallaUser;
  public userSite = environment["memberSite"];
  showUpload = true;
  currentPartner = null;
  isAdmin: boolean = false;
  static readonly maxWidthMobile = 991;
  public prefixDomain = environment.prefixDomain;
  ngOnInit() {
    this.user = this.camerallaAuthService.getUserInfo();
    super.ngOnInit();
    if (this.router.url.includes("/user/group/")) {
      this.showUpload = false;
    }

    this.router.events
      .pipe(filter((routeEvent) => routeEvent instanceof NavigationEnd))
      .subscribe((routeEvent: any) => {
        this.showUpload = !routeEvent.url.includes("/user/group/");
        this.cd.markForCheck();
      });

    this.userService.getPersonalDetails(this.localUserId).then((resolve) => {
      this.isAdmin = resolve.role == PermissionAdminService.adminConst;
      this.user = resolve;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPartner = `/${GlobalVariables.CURRENT_PARTNER.value}`;
      }
    });
    this.menus = this.app.getMenuConfig();

    this.menus.forEach((menu) => {
      menu["isCollapsed"] = false;
    });
  }

  public checkSizeWindowMobile() {
    return screen.width <= NavigationComponent.maxWidthMobile;
  }

  logout() {
    this.camerallaAuthService.logout().then(() => {
      this.router.navigate(['auth'])
    });
  }
}
